const authSessionName = 'user';
const storage = localStorage;

// const getLoginToken = () => {
//     const tok = `provisioning:secret`;
//     const hash = window.btoa(tok);
//     return hash;
// };

const getRefreshToken = () => {
    const data = getData();
    return data?.refresh_token;
};

const getAccessToken = () => {
    const result = getData();
    return result?.data?.token;
};

const getAuthPermissions = () => {
    const data = getData();
    return data?.authorities?.map(o => o.authority) || [];
};

const getUserName = () => {
    const data = getData();
    return data?.title;
};

const getData = () => {
    const auth = storage.getItem(authSessionName);
    if (!auth) return null;
    return JSON.parse(auth);
};

const setData = data => {
    storage.setItem(authSessionName, JSON.stringify(data));
};

const removeData = () => {
    // Clear from both sessionStorage and localStorage
    sessionStorage.removeItem(authSessionName);
    localStorage.removeItem(authSessionName);
    // Clear any other auth-related items
    sessionStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
};

const TokenService = {
    authSessionName,
    // getLoginToken,
    getAccessToken,
    getRefreshToken,
    getUserName,
    getAuthPermissions,
    setData,
    getData,
    removeData,
};

export default TokenService;
